export default __webpack_public_path__ + "static/media/ncx-logo-icon.22d34c9a.svg";